// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
.concurrent-access-container {
  font-family: Montserrat-Regular;
  font-size: 15px;
  height: 50px;
  color: #333333;
  background-color: #ffffff;
  line-height: 25px;
  padding: 13px 10px;
  margin-bottom: 15px;
  border-left: 5px solid #b39841;
  display: none;
}
.concurrent-access-container .icon {
  display: inline-block;
  height: 24px;
  width: 24px;
  vertical-align: top;
  background-image: url('info-gold-solid.06bde661e9db337b.svg');
  background-repeat: no-repeat;
  margin-right: 5px;
}
.concurrent-access-container p {
  display: inline-block;
}
.concurrent-access-container b.small-b {
  display: none;
}
.concurrent-access-container.visible {
  display: block;
}
.concurrent-access-container.small {
  opacity: 1;
  animation-name: fadeIn;
  animation-duration: 3s;
  position: fixed;
  top: 85px;
  left: 256px;
  border-right: 5px solid #b39841;
  width: 42px;
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.2);
  z-index: 20;
}
.concurrent-access-container.small .icon {
  background-image: url('users.351b860eb2c414bc.svg');
  background-repeat: no-repeat;
  margin-left: -3px;
}
.concurrent-access-container.small b {
  display: none;
}
.concurrent-access-container.small b.small-b {
  display: inline-block;
}
.concurrent-access-container.small p {
  display: none;
}
`, "",{"version":3,"sources":["webpack://./node_modules/proceduralsystem-clientcomponents/components/concurrent-access/concurrent-access.component.less"],"names":[],"mappings":"AAEA;EACE;IACE,UAAA;EADF;EAIA;IACE,UAAA;EAFF;AACF;AAKA;EACE,+BAAA;EACA,eAAA;EACA,YAAA;EACA,cAAA;EACA,yBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,8BAAA;EACA,aAAA;AAHF;AAPA;EAaI,qBAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,6DAAA;EACA,4BAAA;EACA,iBAAA;AAHJ;AAhBA;EAuBI,qBAAA;AAJJ;AAnBA;EA2BM,aAAA;AALN;AAQE;EACE,cAAA;AANJ;AASE;EACE,UAAA;EACA,sBAAA;EACA,sBAAA;EAEA,eAAA;EACA,SAAA;EACA,WAAA;EACA,+BAAA;EACA,WAAA;EACA,wCAAA;EACA,WAAA;AARJ;AAHE;EAcI,mDAAA;EACA,4BAAA;EACA,iBAAA;AARN;AARE;EAoBI,aAAA;AATN;AAWM;EACI,qBAAA;AATV;AAdE;EA4BI,aAAA;AAXN","sourcesContent":["@import (reference) '../../styles/variables.less';\n\n@keyframes fadeIn {\n  0% {\n    opacity: 0;\n  }\n\n  100% {\n    opacity: 1;\n  }\n}\n\n.concurrent-access-container {\n  font-family: Montserrat-Regular;\n  font-size: 15px;\n  height: 50px;\n  color: @secondary-base;\n  background-color: @white;\n  line-height: 25px;\n  padding: 13px 10px;\n  margin-bottom: 15px;\n  border-left: 5px solid @primary-90;\n  display: none;\n\n  .icon {\n    display: inline-block;\n    height: 24px;\n    width: 24px;\n    vertical-align: top;\n    background-image: url('../../styles/img/info-gold-solid.svg');\n    background-repeat: no-repeat;\n    margin-right: 5px;\n  }\n\n  p {\n    display: inline-block;\n  }\n\n  b.small-b{\n      display: none;\n  }\n\n  &.visible {\n    display: block;\n  }\n\n  &.small {\n    opacity: 1;\n    animation-name: fadeIn;\n    animation-duration: 3s;\n\n    position: fixed;\n    top: 85px;\n    left: 256px;\n    border-right: 5px solid @primary-90;\n    width: 42px;\n    box-shadow: 0 2px 2px rgba(0,0,0,0.2);\n    z-index: 20;\n\n    .icon {\n      background-image: url(../../styles/img/users.svg);\n      background-repeat: no-repeat;\n      margin-left: -3px;\n    }\n\n    b {\n      display: none;\n\n      &.small-b{\n          display: inline-block;\n      }\n    }\n\n    p {\n      display: none;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
